"use client"

import { ComponentConfig } from "@measured/puck"
import { GoogleMap, InfoWindow, MarkerF, useJsApiLoader } from "@react-google-maps/api"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

export interface LocationMapProps extends CommonStylesProps {
  lat?: string
  lng?: string
  mapHeight?: string
  locationLabel?: string
  type: "fluid" | "custom" | "boxed"
}

export const RenderConfig: ComponentConfig<LocationMapProps> = {
  render: ({ className, type, styles, responsiveType, lat, lng, mapHeight, locationLabel }) => {
    const id = `navigation-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    const { isLoaded } = useJsApiLoader({
      id: "google-map-script",
      googleMapsApiKey: "AIzaSyDGodfPRJzvat54G3EAHM87ymkPGL2HsvE",
    })

    const mapContainerStyle = {
      width: "100%",
      height: type === "fluid" ? "100%" : "400px",
    }

    const center = lat && lng ? { lat: parseFloat(lat), lng: parseFloat(lng) } : { lat: 0, lng: 0 }

    return (
      <>
        {responsiveCSS}
        <div id={id} className={twMerge(className)} style={{ height: mapHeight }}>
          {isLoaded ? (
            <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={16}>
              {lat && lng && (
                <MarkerF position={center}>
                  {locationLabel && (
                    <InfoWindow position={center}>
                      <div>{locationLabel}</div>
                    </InfoWindow>
                  )}
                </MarkerF>
              )}
            </GoogleMap>
          ) : (
            <p>Loading map...</p>
          )}
        </div>
      </>
    )
  },
}
